"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @function InterpolateLinksWithComponent - replaces a placeholder {placeholder} in source string with supplied links and returns a new component to render
 * @param.content - string with tagName in format 'abc {linkName} def'
 * @param.links - links array
 */
function InterpolateLinksWithComponent(content, links) {
    if (content === void 0) { content = ''; }
    if (links === void 0) { links = []; }
    var contentSplits = content.split(new RegExp("{[a-zA-Z_-]+}"));
    var component = [], linksIndex = 0, concatIndex = 0;
    component.push(React.createElement("span", { key: concatIndex }, contentSplits[concatIndex++]));
    while (concatIndex < contentSplits.length && linksIndex < links.length) {
        component.push(links[linksIndex++]);
        component.push(React.createElement("span", { key: concatIndex }, contentSplits[concatIndex++]));
    }
    return (React.createElement(React.Fragment, null, component));
}
exports.InterpolateLinksWithComponent = InterpolateLinksWithComponent;
